import React from "react";
import { PasswordReset } from "../../components/PasswordReset/PasswordReset";
import LoginContainer from "../../components/LoginContainer/LoginContainer";

export const PasswordResetWrapper = () => {
  return (
    <LoginContainer>
      <PasswordReset />
    </LoginContainer>
  );
};
